module.exports = __webpack_public_path__ + "icon-user-active.png?817237c8a9d43fe6e23e9ecc39f4ff7b";